import React, { Component } from 'react';

// Компонент горизонтальной линии
const HorizontalLine = () => (
    <div style={{
        width: '100%',
        height: '1px',
        background: '#DFE0EB',
        margin: '1.5em 0'
    }}></div>
);

class AffiliatePage extends Component {
    state = {
        loading: false,
        initialLoading: true,
        step: 1, // 1 - форма, 2 - ссылка
        fullName: '',
        affiliateData: null,
        referrals: [],
        currentPage: 1,
        itemsPerPage: 10,
        stats: {
            totalReferrals: 0,
            totalEarnings: 0,
            pendingPayout: 0,
            paidOut: 0,
            level1Count: 0,
            level2Count: 0
        },
        pagination: {
            totalPages: 1,
            hasNext: false,
            hasPrevious: false
        },
        error: null
    }

    componentDidMount() {
        this.loadReferralData();
    }

    getAuthToken = () => {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'clickanti_token') {
                return value;
            }
        }
        return null;
    }

    loadReferralData = async (page = 1) => {
        const token = this.getAuthToken();
        
        if (!token) {
            this.setState({ 
                initialLoading: false,
                error: 'Токен авторизации не найден. Пожалуйста, войдите в систему.'
            });
            return;
        }

        this.setState({ initialLoading: true, error: null });

        try {
            const response = await fetch(
                `https://api.clickanti.ru/api/users/referral/stats/?page=${page}&page_size=${this.state.itemsPerPage}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`Ошибка загрузки данных: ${response.status}`);
            }

            const data = await response.json();

            // Парсим сумму (убираем пробелы и ₽)
            const parseAmount = (str) => {
                if (!str) return 0;
                return parseInt(str.replace(/\s/g, '').replace('₽', '')) || 0;
            };

            // Проверяем наличие реферальной ссылки
            const hasReferralLink = data.statistics?.referral_link && 
                                   data.statistics.referral_link.trim() !== '';

            this.setState({
                referrals: data.referrals || [],
                stats: {
                    totalReferrals: data.statistics?.total_referrals || 0,
                    totalEarnings: parseAmount(data.statistics?.total_commission),
                    pendingPayout: parseAmount(data.statistics?.pending_payout),
                    paidOut: parseAmount(data.statistics?.paid_out),
                    level1Count: data.statistics?.level_1_count || 0,
                    level2Count: data.statistics?.level_2_count || 0
                },
                pagination: {
                    totalPages: data.pagination?.total_pages || 1,
                    hasNext: data.pagination?.has_next || false,
                    hasPrevious: data.pagination?.has_previous || false
                },
                currentPage: page,
                initialLoading: false,
                // Показываем step 2 только если есть реферальная ссылка
                step: hasReferralLink ? 2 : 1,
                affiliateData: hasReferralLink ? {
                    link: data.statistics.referral_link,
                    id: data.statistics.referral_link.split('ref=')[1] || 'N/A'
                } : null
            });
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
            this.setState({
                error: error.message,
                initialLoading: false
            });
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!this.state.fullName.trim()) {
            this.setState({ error: 'Пожалуйста, укажите ФИО для выплат' });
            return;
        }

        const token = this.getAuthToken();
        
        if (!token) {
            this.setState({ error: 'Токен авторизации не найден. Пожалуйста, войдите в систему.' });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(
                'https://api.clickanti.ru/api/users/referral/generate/',
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        full_name: this.state.fullName.trim()
                    })
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || data.detail || `Ошибка: ${response.status}`);
            }

            this.setState({
                loading: false,
                step: 2,
                affiliateData: {
                    id: data.referral_id,
                    link: data.referral_link,
                    createdDate: new Date().toLocaleDateString('ru-RU'),
                    fullName: this.state.fullName.trim()
                }
            });

            // Перезагружаем данные для обновления статистики
            this.loadReferralData();
        } catch (error) {
            console.error('Ошибка создания партнерской ссылки:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    copyToClipboard = () => {
        if (this.state.affiliateData?.link) {
            navigator.clipboard.writeText(this.state.affiliateData.link).then(() => {
                alert('Ссылка скопирована в буфер обмена!');
            });
        }
    }

    formatCurrency = (amount) => {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₽';
    }

    getStatusColor = (status) => {
        return status === 'Активен' ? '#39b339' : '#ff9900';
    }

    getTypeColor = (type) => {
        return type === 'Партнер' ? '#9C27B0' : '#0767F4';
    }

    handlePageChange = (pageNumber) => {
        this.loadReferralData(pageNumber);
    }

    renderPagination = () => {
        const { currentPage, pagination } = this.state;
        const { totalPages } = pagination;
        
        if (totalPages <= 1) return null;

        const pages = [];
        const maxVisiblePages = 5;
        
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        
        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '2em',
                gap: '0.5em'
            }}>
                <button 
                    onClick={() => this.handlePageChange(currentPage - 1)}
                    disabled={!pagination.hasPrevious}
                    style={{
                        padding: '0.5em 1em',
                        border: '1px solid #ddd',
                        background: 'white',
                        color: !pagination.hasPrevious ? '#ccc' : '#666',
                        cursor: !pagination.hasPrevious ? 'not-allowed' : 'pointer',
                        borderRadius: '0.3em'
                    }}
                >
                    ←
                </button>
                
                {startPage > 1 && (
                    <>
                        <button 
                            onClick={() => this.handlePageChange(1)}
                            style={{
                                padding: '0.5em 1em',
                                border: '1px solid #ddd',
                                background: 'white',
                                color: '#666',
                                cursor: 'pointer',
                                borderRadius: '0.3em'
                            }}
                        >
                            1
                        </button>
                        {startPage > 2 && <span style={{color: '#9197B3'}}>...</span>}
                    </>
                )}
                
                {pages.map(page => (
                    <button 
                        key={page}
                        onClick={() => this.handlePageChange(page)}
                        style={{
                            padding: '0.5em 1em',
                            border: '1px solid',
                            background: currentPage === page ? '#0767F4' : 'white',
                            color: currentPage === page ? 'white' : '#666',
                            cursor: 'pointer',
                            borderRadius: '0.3em'
                        }}
                    >
                        {page}
                    </button>
                ))}
                
                {endPage < totalPages && (
                    <>
                        {endPage < totalPages - 1 && <span style={{color: '#9197B3'}}>...</span>}
                        <button 
                            onClick={() => this.handlePageChange(totalPages)}
                            style={{
                                padding: '0.5em 1em',
                                border: '1px solid #ddd',
                                background: 'white',
                                color: '#666',
                                cursor: 'pointer',
                                borderRadius: '0.3em'
                            }}
                        >
                            {totalPages}
                        </button>
                    </>
                )}
                
                <button 
                    onClick={() => this.handlePageChange(currentPage + 1)}
                    disabled={!pagination.hasNext}
                    style={{
                        padding: '0.5em 1em',
                        border: '1px solid #ddd',
                        background: 'white',
                        color: !pagination.hasNext ? '#ccc' : '#666',
                        cursor: !pagination.hasNext ? 'not-allowed' : 'pointer',
                        borderRadius: '0.3em'
                    }}
                >
                    →
                </button>
            </div>
        );
    }

    render() {
        const { loading, initialLoading, step, fullName, affiliateData, referrals, stats, error } = this.state;

        if (initialLoading) {
            return (
                <div className='createPage' style={{textAlign: 'center', padding: '3em'}}>
                    <div style={{fontSize: '1.2em', color: '#666'}}>Загрузка...</div>
                </div>
            );
        }

        if (error && !affiliateData) {
            return (
                <div className='createPage'>
                    <h1>Партнерская программа</h1>
                    <HorizontalLine />
                    <div style={{
                        padding: '2em',
                        background: '#fff3cd',
                        border: '1px solid #ffc107',
                        borderRadius: '0.5em',
                        color: '#856404'
                    }}>
                        ⚠️ {error}
                    </div>
                </div>
            );
        }

        return (
            <div className='createPage'>
                <h1>Партнерская программа</h1>
                <HorizontalLine />
                
                {/* Информация о комиссиях */}
                <div className='editBlock' style={{marginTop: '2em'}}>
                    <div className='editBlock_name'>
                        <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                            Условия партнерства
                        </h2>
                    </div>
                    
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '2em',
                        marginTop: '1.5em'
                    }}>
                        <div>
                            <div style={{
                                fontSize: '1.2em',
                                fontWeight: '600',
                                color: '#0767F4',
                                marginBottom: '0.5em'
                            }}>
                                35% от платежей клиентов
                            </div>
                            <div style={{color: '#666', lineHeight: '1.6'}}>
                                За каждого приведенного клиента вы получаете 35% от всех его платежей пожизненно.
                            </div>
                        </div>
                        
                        <div>
                            <div style={{
                                fontSize: '1.2em',
                                fontWeight: '600',
                                color: '#9C27B0',
                                marginBottom: '0.5em'
                            }}>
                                15% от дохода партнеров
                            </div>
                            <div style={{color: '#666', lineHeight: '1.6'}}>
                                За каждого приведенного партнера вы получаете 15% от его дохода по всем его клиентам.
                            </div>
                        </div>
                    </div>
                    
                    <div style={{
                        marginTop: '1.5em',
                        padding: '1.2em',
                        background: '#e8f4f8',
                        borderRadius: '0.5em',
                        color: '#0767F4'
                    }}>
                        <div style={{fontWeight: '600', marginBottom: '0.3em'}}>
                            💡 Многоуровневая система
                        </div>
                        <div>
                            Вы получаете не только с прямых рефералов, но и с рефералов ваших партнеров (2-й уровень).
                        </div>
                    </div>
                </div>

                {step === 1 ? (
                    /* ФОРМА РЕГИСТРАЦИИ */
                    <div className='editBlock' style={{marginTop: '2em'}}>
                        <div className='editBlock_name'>
                            <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                                Получить партнерскую ссылку
                            </h2>
                            <div style={{
                                display: 'inline-block',
                                marginLeft: '2em',
                                color: '#9197B3',
                                fontSize: '0.9em'
                            }}>
                                Укажите ФИО для выплат
                            </div>
                        </div>
                        
                        {error && (
                            <div style={{
                                marginTop: '1em',
                                padding: '1em',
                                background: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '0.5em',
                                color: '#856404'
                            }}>
                                ⚠️ {error}
                            </div>
                        )}
                        
                        <form onSubmit={this.handleSubmit} style={{marginTop: '1.5em'}}>
                            <div style={{
                                maxWidth: '500px',
                                margin: '0 auto'
                            }}>
                                <div className='inputsBlock_block'>
                                    <div className='inputsBlock_block_label' style={{color: '#252733', fontWeight: '500', marginBottom: '0.8em'}}>
                                        ФИО для выплат
                                    </div>
                                    <input
                                        type="text"
                                        value={fullName}
                                        onChange={(e) => this.setState({ fullName: e.target.value, error: null })}
                                        placeholder="Иванов Иван Иванович"
                                        style={{
                                            width: '100%',
                                            padding: '0.8em',
                                            border: '1px solid #ddd',
                                            borderRadius: '0.4em',
                                            fontSize: '1em'
                                        }}
                                        required
                                    />
                                    <div style={{
                                        marginTop: '0.5em',
                                        fontSize: '0.9em',
                                        color: '#9197B3'
                                    }}>
                                        На это имя будут оформляться выплаты по партнерской программе
                                    </div>
                                </div>
                            </div>
                            
                            <div style={{textAlign: 'center', marginTop: '2em'}}>
                                <button 
                                    type="submit"
                                    className='bigButton'
                                    disabled={loading || !fullName.trim()}
                                    style={{
                                        padding: '0.8em 3em',
                                        fontSize: '1.1em',
                                        opacity: loading || !fullName.trim() ? 0.7 : 1,
                                        cursor: loading || !fullName.trim() ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {loading ? 'Создание ссылки...' : 'Получить партнерскую ссылку'}
                                </button>
                            </div>
                        </form>
                    </div>
                ) : (
                    /* ПАРТНЕРСКАЯ ССЫЛКА И СТАТИСТИКА */
                    <div>
                        <div className='editBlock' style={{marginTop: '2em'}}>
                            <div className='editBlock_name'>
                                <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                                    Ваша партнерская ссылка
                                </h2>
                            </div>
                            
                            <div style={{marginTop: '1.5em'}}>
                                <div style={{
                                    background: '#F3F3F3',
                                    borderRadius: '0.5em',
                                    padding: '1em',
                                    fontFamily: 'monospace',
                                    fontSize: '1.1em',
                                    wordBreak: 'break-all',
                                    marginBottom: '1em'
                                }}>
                                    {affiliateData?.link}
                                </div>
                                
                                <div style={{
                                    display: 'flex',
                                    gap: '1em',
                                    alignItems: 'center'
                                }}>
                                    <button 
                                        onClick={this.copyToClipboard}
                                        className='btn1'
                                        style={{
                                            padding: '0.8em 2em',
                                            fontSize: '1em'
                                        }}
                                    >
                                        Копировать ссылку
                                    </button>
                                    
                                    
                                </div>
                            </div>
                        </div>

                        {/* Статистика */}
                        <div className='editBlock' style={{marginTop: '2em'}}>
                            <div className='editBlock_name'>
                                <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                                    Ваша статистика
                                </h2>
                            </div>
                            
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                gap: '1.5em',
                                marginTop: '1.5em'
                            }}>
                                <div style={{
                                    padding: '1.5em',
                                    background: '#FAFBFF',
                                    borderRadius: '0.8em',
                                    textAlign: 'center'
                                }}>
                                    <div style={{
                                        fontSize: '0.9em',
                                        color: '#9197B3',
                                        marginBottom: '0.5em'
                                    }}>
                                        Всего рефералов
                                    </div>
                                    <div style={{
                                        fontSize: '2em',
                                        fontWeight: '700',
                                        color: '#0767F4'
                                    }}>
                                        {stats.totalReferrals}
                                    </div>
                                    <div style={{
                                        fontSize: '0.8em',
                                        color: '#9197B3',
                                        marginTop: '0.3em'
                                    }}>
                                        Уровень 1: {stats.level1Count} | Уровень 2: {stats.level2Count}
                                    </div>
                                </div>
                                
                                <div style={{
                                    padding: '1.5em',
                                    background: '#FAFBFF',
                                    borderRadius: '0.8em',
                                    textAlign: 'center'
                                }}>
                                    <div style={{
                                        fontSize: '0.9em',
                                        color: '#9197B3',
                                        marginBottom: '0.5em'
                                    }}>
                                        Всего заработано
                                    </div>
                                    <div style={{
                                        fontSize: '2em',
                                        fontWeight: '700',
                                        color: '#39b339'
                                    }}>
                                        {this.formatCurrency(stats.totalEarnings)}
                                    </div>
                                </div>
                                
                                <div style={{
                                    padding: '1.5em',
                                    background: '#FAFBFF',
                                    borderRadius: '0.8em',
                                    textAlign: 'center'
                                }}>
                                    <div style={{
                                        fontSize: '0.9em',
                                        color: '#9197B3',
                                        marginBottom: '0.5em'
                                    }}>
                                        Ожидает выплаты
                                    </div>
                                    <div style={{
                                        fontSize: '2em',
                                        fontWeight: '700',
                                        color: '#ff9900'
                                    }}>
                                        {this.formatCurrency(stats.pendingPayout)}
                                    </div>
                                </div>
                                
                                <div style={{
                                    padding: '1.5em',
                                    background: '#FAFBFF',
                                    borderRadius: '0.8em',
                                    textAlign: 'center'
                                }}>
                                    <div style={{
                                        fontSize: '0.9em',
                                        color: '#9197B3',
                                        marginBottom: '0.5em'
                                    }}>
                                        Выплачено
                                    </div>
                                    <div style={{
                                        fontSize: '2em',
                                        fontWeight: '700',
                                        color: '#666'
                                    }}>
                                        {this.formatCurrency(stats.paidOut)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Таблица рефералов */}
                        {referrals.length > 0 && (
                            <div className='editBlock' style={{marginTop: '2em'}}>
                                <div className='editBlock_name'>
                                    <h2 style={{color: '#252733', fontSize: '1.4em', fontWeight: '600'}}>
                                        Ваши рефералы
                                    </h2>
                                </div>
                                
                                <div style={{overflowX: 'auto', marginTop: '1.5em'}}>
                                    <table style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        fontSize: '0.95em'
                                    }}>
                                        <thead>
                                            <tr style={{
                                                background: '#F3F3F3',
                                                color: '#9197B3',
                                                fontWeight: '600'
                                            }}>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Имя</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Email</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Тип</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Статус</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Уровень</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Дата рег.</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Потратил</th>
                                                <th style={{padding: '1em', textAlign: 'left'}}>Ваша комиссия</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {referrals.map(referral => (
                                                <tr 
                                                    key={referral.id}
                                                    style={{
                                                        borderBottom: '1px solid #F3F3F3'
                                                    }}
                                                >
                                                    <td style={{padding: '1em', fontWeight: '500'}}>
                                                        {referral.full_name}
                                                    </td>
                                                    <td style={{padding: '1em', color: '#666', fontSize: '0.9em'}}>
                                                        {referral.email}
                                                    </td>
                                                    <td style={{padding: '1em'}}>
                                                        <span style={{
                                                            padding: '0.3em 0.8em',
                                                            borderRadius: '1em',
                                                            background: this.getTypeColor(referral.user_type),
                                                            color: 'white',
                                                            fontSize: '0.85em'
                                                        }}>
                                                            {referral.user_type}
                                                        </span>
                                                    </td>
                                                    <td style={{padding: '1em'}}>
                                                        <span style={{
                                                            color: this.getStatusColor(referral.status),
                                                            fontWeight: '500'
                                                        }}>
                                                            {referral.status}
                                                        </span>
                                                    </td>
                                                    <td style={{padding: '1em', textAlign: 'center'}}>
                                                        <span style={{
                                                            padding: '0.2em 0.6em',
                                                            background: referral.level === 1 ? '#0767F4' : '#9C27B0',
                                                            color: 'white',
                                                            borderRadius: '0.3em',
                                                            fontSize: '0.85em'
                                                        }}>
                                                            {referral.level}
                                                        </span>
                                                    </td>
                                                    <td style={{padding: '1em', color: '#666'}}>
                                                        {referral.registered_at}
                                                    </td>
                                                    <td style={{padding: '1em', fontWeight: '600', color: '#252733'}}>
                                                        {referral.total_spent}
                                                    </td>
                                                    <td style={{padding: '1em', fontWeight: '600', color: '#39b339'}}>
                                                        {referral.your_commission}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                
                                {/* Пагинация */}
                                {this.renderPagination()}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default AffiliatePage;